// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Leetcode Wizard
 * Leetcode Wizard API Description
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CreateCheckoutSessionResponseDto
 */
export interface CreateCheckoutSessionResponseDto {
    /**
     *
     * @type {string}
     * @memberof CreateCheckoutSessionResponseDto
     */
    url: string;
}

/**
 * Check if a given object implements the CreateCheckoutSessionResponseDto interface.
 */
export function instanceOfCreateCheckoutSessionResponseDto(
    value: object,
): value is CreateCheckoutSessionResponseDto {
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function CreateCheckoutSessionResponseDtoFromJSON(
    json: any,
): CreateCheckoutSessionResponseDto {
    return CreateCheckoutSessionResponseDtoFromJSONTyped(json, false);
}

export function CreateCheckoutSessionResponseDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): CreateCheckoutSessionResponseDto {
    if (json == null) {
        return json;
    }
    return {
        url: json['url'],
    };
}

export function CreateCheckoutSessionResponseDtoToJSON(
    value?: CreateCheckoutSessionResponseDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        url: value['url'],
    };
}
